/**
 * 批量事务抽屉 V4.0 - 事务头部组件
 * 显示选中的航班信息
 */

import React, { useState, useCallback } from "react";
import { Card, Space, Tag, Button } from "antd";
import { InfoCircleOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { useBatchTransactionContext } from "../context/BatchTransactionContext";
import TimeZoneSelector from "../../../../components/TimeZoneSelector";

const TransactionHeader = () => {
    const { state } = useBatchTransactionContext();
    const { selectedFlights, dataLoadingStatus } = state;

    // 收缩状态管理，默认收缩
    const [isCollapsed, setIsCollapsed] = useState(true);
    const maxDisplayCount = 6; // 收缩状态下最多显示6个航班

    // 切换收缩状态
    const toggleCollapsed = useCallback(() => {
        setIsCollapsed(!isCollapsed);
    }, [isCollapsed]);

    // 如果数据还在加载中，显示加载状态
    if (dataLoadingStatus === "LOADING") {
        return (
            <Card size="small" style={{ marginBottom: 16 }}>
                <div style={{ textAlign: "center", padding: "20px 0" }}>
                    <InfoCircleOutlined style={{ fontSize: 16, color: "#1890ff", marginRight: 8 }} />
                    正在加载事务数据...
                </div>
            </Card>
        );
    }

    // 根据收缩状态决定显示的航班数量
    const displayFlights = isCollapsed ? selectedFlights.slice(0, maxDisplayCount) : selectedFlights;
    const hasMoreFlights = selectedFlights.length > maxDisplayCount;

    return (
        <Card size="small" style={{ marginBottom: 16 }}>
            <div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", marginBottom: 8 }}>
                    <Space>
                        <span style={{ fontSize: "14px", fontWeight: "bold" }}>选中航班</span>
                        <Tag color="blue">{selectedFlights.length}个</Tag>
                        {hasMoreFlights && (
                            <Button type="text" size="small" icon={isCollapsed ? <DownOutlined /> : <UpOutlined />} onClick={toggleCollapsed} style={{ padding: "0 4px", height: "auto", fontSize: "12px" }}>
                                {isCollapsed ? `展开全部` : "收缩"}
                            </Button>
                        )}
                    </Space>
                    <TimeZoneSelector />
                </div>

                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "6px",
                        alignItems: "flex-start",
                    }}
                >
                    {displayFlights.map((flight, index) => (
                        <Tag
                            key={flight.id}
                            color="blue"
                            style={{
                                margin: 0,
                                fontSize: "12px",
                                lineHeight: "20px",
                                padding: "4px 8px",
                            }}
                        >
                            {index + 1}. {flight.flight_number} ({flight.flight_date}) {flight.departure_airport}-{flight.arrival_airport}
                        </Tag>
                    ))}
                    {isCollapsed && hasMoreFlights && (
                        <Tag
                            color="default"
                            style={{
                                margin: 0,
                                fontSize: "12px",
                                lineHeight: "20px",
                                padding: "4px 8px",
                                cursor: "pointer",
                                border: "1px dashed #d9d9d9",
                                background: "#fafafa",
                            }}
                            onClick={toggleCollapsed}
                        >
                            还有 {selectedFlights.length - maxDisplayCount} 个航班...
                        </Tag>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default TransactionHeader;
